import { render, staticRenderFns } from "./VideosPrew.vue?vue&type=template&id=20cf3c40&scoped=true&"
import script from "./VideosPrew.vue?vue&type=script&lang=js&"
export * from "./VideosPrew.vue?vue&type=script&lang=js&"
import style0 from "./VideosPrew.vue?vue&type=style&index=0&id=20cf3c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf3c40",
  null
  
)

export default component.exports